import { render, staticRenderFns } from "./MentorBasicCard.vue?vue&type=template&id=22bd7736&"
import script from "./MentorBasicCard.vue?vue&type=script&lang=js&"
export * from "./MentorBasicCard.vue?vue&type=script&lang=js&"
import style0 from "./MentorBasicCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports